import { render } from "./DietDiagnosis.vue?vue&type=template&id=3a913990"
import script from "./DietDiagnosis.vue?vue&type=script&lang=js"
export * from "./DietDiagnosis.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__